import React from 'react'

function Salary ({ className, fill }) {
  return (
    <svg fill={fill} className={className} viewBox="0 0 24 24">
      <path d="M12,24A12,12,0,1,1,24,12,12,12,0,0,1,12,24ZM12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Z"/>
      <path d="M12.42,17.09v1.09h-.84V17.11A3.52,3.52,0,0,1,8.5,15.25l.87-.83A2.66,2.66,0,0,0,11.64,16V12.3L11.1,12c-1.2-.55-2.16-1.21-2.16-2.71a2.77,2.77,0,0,1,2.79-2.72v-1h.84v1A3.07,3.07,0,0,1,15,8l-.73.86A2.45,2.45,0,0,0,12.5,7.7v3.46l.9.43a2.8,2.8,0,0,1,1.9,2.65A3,3,0,0,1,12.42,17.09Zm-2.18-7.9c0,.85.65,1.24,1.22,1.52l.24.12V7.66A1.5,1.5,0,0,0,10.24,9.19Zm2.58,3.54-.37-.19V16A1.64,1.64,0,0,0,14,14.38,1.68,1.68,0,0,0,12.82,12.73Z"/>
    </svg>
  )
}

Salary.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Salary
